import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, MessageSquareIcon, UserIcon, PhoneIcon, MailIcon, MapPinIcon, CalendarIcon, DollarSignIcon, UsersIcon, ClockIcon, CheckCircleIcon, XCircleIcon, AlertCircleIcon, EditIcon, SendIcon, PlusIcon, PackageIcon, FileTextIcon } from 'lucide-react';
// Mock enquiries data (same as in EnquiriesModule)
const enquiriesData = [{
  id: 1,
  customer: {
    name: 'Jennifer Williams',
    email: 'jwilliams@example.com',
    phone: '+1 (555) 987-6543'
  },
  destination: 'Caribbean Cruise',
  travelDates: 'Aug 5 - Aug 12, 2023',
  budget: '$2,000 - $3,000',
  travelers: '2 adults',
  status: 'new',
  priority: 'high',
  message: "Looking for a relaxing cruise package for our anniversary. We're interested in a balcony room and would like to know what dining options are available. Also, are there any special packages for anniversary celebrations?",
  dateReceived: '2023-06-10T14:30:00',
  assignedTo: 'Sarah Johnson',
  lastActivity: '2023-06-10T14:30:00',
  activities: [{
    id: 1,
    type: 'note',
    content: 'Called customer to discuss cruise options. They are most interested in Caribbean destinations.',
    date: '2023-06-10T15:45:00',
    user: 'Sarah Johnson'
  }]
}, {
  id: 2,
  customer: {
    name: 'Robert Chen',
    email: 'robert.chen@example.com',
    phone: '+1 (555) 123-4567'
  },
  destination: 'Japan',
  travelDates: 'Oct 15 - Oct 28, 2023',
  budget: '$5,000 - $7,000',
  travelers: '2 adults, 1 child',
  status: 'in-progress',
  priority: 'medium',
  message: 'Interested in a family-friendly cultural tour of Japan with some time in Tokyo and Kyoto. Our child is 8 years old. We would like to experience traditional Japanese culture, visit some historical sites, and also include some activities that would be fun for our child.',
  dateReceived: '2023-06-08T09:15:00',
  assignedTo: 'Sarah Johnson',
  lastActivity: '2023-06-09T11:45:00',
  activities: [{
    id: 1,
    type: 'note',
    content: 'Initial review of enquiry. Will prepare Japan family tour options.',
    date: '2023-06-08T10:30:00',
    user: 'Sarah Johnson'
  }, {
    id: 2,
    type: 'email',
    content: 'Sent email with initial tour options and requested more information about specific interests.',
    date: '2023-06-09T11:45:00',
    user: 'Sarah Johnson'
  }]
}, {
  id: 3,
  customer: {
    name: 'Michael Torres',
    email: 'mtorres@example.com',
    phone: '+1 (555) 456-7890'
  },
  destination: 'European Tour',
  travelDates: 'Sep 12 - Sep 26, 2023',
  budget: '$4,000 - $6,000',
  travelers: '1 adult',
  status: 'quoted',
  priority: 'medium',
  message: "Looking for a self-guided tour of major European cities with focus on historical sites. I'm particularly interested in visiting Rome, Paris, and Barcelona. I prefer to travel by train between cities and would like accommodations that are centrally located.",
  dateReceived: '2023-06-05T16:20:00',
  assignedTo: 'Sarah Johnson',
  lastActivity: '2023-06-07T10:30:00',
  activities: [{
    id: 1,
    type: 'note',
    content: 'Customer prefers boutique hotels and is interested in guided tours of historical sites.',
    date: '2023-06-06T09:15:00',
    user: 'Sarah Johnson'
  }, {
    id: 2,
    type: 'quote',
    content: 'Sent quote for 14-day European tour including Rome, Paris, and Barcelona with rail transportation.',
    date: '2023-06-07T10:30:00',
    user: 'Sarah Johnson',
    quoteAmount: 5450
  }]
}, {
  id: 4,
  customer: {
    name: 'Emily Wilson',
    email: 'ewilson@example.com',
    phone: '+1 (555) 789-0123'
  },
  destination: 'Bali',
  travelDates: 'Jul 20 - Jul 27, 2023',
  budget: '$3,000 - $4,000',
  travelers: '2 adults',
  status: 'booked',
  priority: 'low',
  message: "Honeymoon trip to Bali. Looking for luxury accommodations and romantic activities. We're interested in a private villa with a pool, couples spa treatments, and a sunset dinner cruise.",
  dateReceived: '2023-05-28T11:10:00',
  assignedTo: 'David Miller',
  lastActivity: '2023-06-02T15:45:00',
  activities: [{
    id: 1,
    type: 'note',
    content: 'Initial consultation call completed. Couple is flexible on exact dates.',
    date: '2023-05-29T14:20:00',
    user: 'David Miller'
  }, {
    id: 2,
    type: 'quote',
    content: 'Prepared and sent honeymoon package quote with options for villa upgrades.',
    date: '2023-05-31T11:30:00',
    user: 'David Miller',
    quoteAmount: 3850
  }, {
    id: 3,
    type: 'booking',
    content: 'Booking confirmed for 7-night stay at Luxury Villas Bali with honeymoon package.',
    date: '2023-06-02T15:45:00',
    user: 'David Miller',
    bookingAmount: 3950,
    bookingRef: 'BK-78945'
  }]
}, {
  id: 5,
  customer: {
    name: 'James Rodriguez',
    email: 'jrodriguez@example.com',
    phone: '+1 (555) 234-5678'
  },
  destination: 'African Safari',
  travelDates: 'Nov 10 - Nov 20, 2023',
  budget: '$8,000 - $12,000',
  travelers: '4 adults',
  status: 'closed',
  priority: 'low',
  message: 'Group of friends interested in a luxury safari experience in Tanzania or Kenya. We want to see the Big Five and experience authentic local culture. Prefer luxury tented camps.',
  dateReceived: '2023-05-15T08:45:00',
  assignedTo: 'Sarah Johnson',
  lastActivity: '2023-05-20T09:30:00',
  activities: [{
    id: 1,
    type: 'note',
    content: 'Initial review of safari options for group.',
    date: '2023-05-16T10:15:00',
    user: 'Sarah Johnson'
  }, {
    id: 2,
    type: 'quote',
    content: 'Prepared luxury safari quote with options in both Tanzania and Kenya.',
    date: '2023-05-18T14:30:00',
    user: 'Sarah Johnson',
    quoteAmount: 9800
  }, {
    id: 3,
    type: 'note',
    content: 'Customer informed us they decided to postpone their trip until next year.',
    date: '2023-05-20T09:30:00',
    user: 'Sarah Johnson'
  }, {
    id: 4,
    type: 'status',
    content: 'Enquiry marked as closed due to postponement.',
    date: '2023-05-20T09:35:00',
    user: 'Sarah Johnson'
  }]
}];
export const EnquiryDetails = () => {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const [enquiry, setEnquiry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newNote, setNewNote] = useState('');
  useEffect(() => {
    // Simulate API fetch
    setLoading(true);
    setTimeout(() => {
      const foundEnquiry = enquiriesData.find(e => e.id === parseInt(id));
      setEnquiry(foundEnquiry);
      setLoading(false);
    }, 300);
  }, [id]);
  if (loading) {
    return <div className="flex items-center justify-center h-64" data-id="element-2493">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" data-id="element-2494"></div>
      </div>;
  }
  if (!enquiry) {
    return <div className="flex flex-col items-center justify-center h-64" data-id="element-2495">
        <MessageSquareIcon className="h-12 w-12 text-gray-300 mb-4" data-id="element-2496" />
        <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-2497">
          Enquiry not found
        </h3>
        <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" onClick={() => navigate('/enquiries')} data-id="element-2498">
          Back to Enquiries
        </button>
      </div>;
  }
  const getStatusBadge = status => {
    switch (status) {
      case 'new':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-2499">
            <ClockIcon className="h-3 w-3 mr-1" data-id="element-2500" />
            New
          </span>;
      case 'in-progress':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-2501">
            <AlertCircleIcon className="h-3 w-3 mr-1" data-id="element-2502" />
            In Progress
          </span>;
      case 'quoted':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800" data-id="element-2503">
            <MessageSquareIcon className="h-3 w-3 mr-1" data-id="element-2504" />
            Quoted
          </span>;
      case 'booked':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-2505">
            <CheckCircleIcon className="h-3 w-3 mr-1" data-id="element-2506" />
            Booked
          </span>;
      case 'closed':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-2507">
            <XCircleIcon className="h-3 w-3 mr-1" data-id="element-2508" />
            Closed
          </span>;
      default:
        return null;
    }
  };
  const getPriorityBadge = priority => {
    switch (priority) {
      case 'high':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-2509">
            High Priority
          </span>;
      case 'medium':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-2510">
            Medium Priority
          </span>;
      case 'low':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-2511">
            Low Priority
          </span>;
      default:
        return null;
    }
  };
  const formatDate = dateString => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  const getActivityIcon = type => {
    switch (type) {
      case 'note':
        return <MessageSquareIcon className="h-5 w-5 text-blue-500" data-id="element-2512" />;
      case 'email':
        return <MailIcon className="h-5 w-5 text-purple-500" data-id="element-2513" />;
      case 'quote':
        return <FileTextIcon className="h-5 w-5 text-amber-500" data-id="element-2514" />;
      case 'booking':
        return <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-2515" />;
      case 'status':
        return <AlertCircleIcon className="h-5 w-5 text-gray-500" data-id="element-2516" />;
      default:
        return <ClockIcon className="h-5 w-5 text-gray-500" data-id="element-2517" />;
    }
  };
  const handleAddNote = () => {
    if (!newNote.trim()) return;
    // In a real app, this would be an API call
    console.log('Adding note:', newNote);
    setNewNote('');
    // Simulate adding a note to the activity timeline
    const updatedEnquiry = {
      ...enquiry,
      activities: [{
        id: Math.max(...enquiry.activities.map(a => a.id)) + 1,
        type: 'note',
        content: newNote,
        date: new Date().toISOString(),
        user: 'Sarah Johnson'
      }, ...enquiry.activities],
      lastActivity: new Date().toISOString()
    };
    setEnquiry(updatedEnquiry);
  };
  const handleCreateQuote = () => {
    navigate('/products', {
      state: {
        enquiryId: enquiry.id
      }
    });
  };
  return <div className="space-y-6" data-id="element-2518">
      <div className="flex items-center" data-id="element-2519">
        <button className="mr-4 text-gray-500 hover:text-gray-700" onClick={() => navigate('/enquiries')} data-id="element-2520">
          <ChevronLeftIcon className="h-6 w-6" data-id="element-2521" />
        </button>
        <div data-id="element-2522">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-2523">Enquiry Details</h1>
          <p className="text-sm text-gray-500" data-id="element-2524">
            {enquiry.customer.name} - {enquiry.destination}
          </p>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-6" data-id="element-2525">
        {/* Main content - left 2/3 */}
        <div className="col-span-2 space-y-6" data-id="element-2526">
          {/* Enquiry details card */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-2527">
            <div className="p-6" data-id="element-2528">
              <div className="flex justify-between items-start mb-4" data-id="element-2529">
                <div data-id="element-2530">
                  <h2 className="text-lg font-medium text-gray-800" data-id="element-2531">
                    Enquiry Information
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-2532">
                    Received {formatDate(enquiry.dateReceived)}
                  </p>
                </div>
                <div className="flex space-x-2" data-id="element-2533">
                  {getStatusBadge(enquiry.status)}
                  {getPriorityBadge(enquiry.priority)}
                </div>
              </div>
              <div className="mt-4 p-4 bg-gray-50 rounded-lg" data-id="element-2534">
                <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-2535">
                  Customer Message
                </h3>
                <p className="text-gray-700 whitespace-pre-line" data-id="element-2536">
                  {enquiry.message}
                </p>
              </div>
              <div className="mt-6 grid grid-cols-2 gap-4" data-id="element-2537">
                <div className="flex items-start" data-id="element-2538">
                  <MapPinIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-2" data-id="element-2539" />
                  <div data-id="element-2540">
                    <p className="text-sm font-medium text-gray-500" data-id="element-2541">
                      Destination
                    </p>
                    <p className="text-gray-800" data-id="element-2542">{enquiry.destination}</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-2543">
                  <CalendarIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-2" data-id="element-2544" />
                  <div data-id="element-2545">
                    <p className="text-sm font-medium text-gray-500" data-id="element-2546">
                      Travel Dates
                    </p>
                    <p className="text-gray-800" data-id="element-2547">{enquiry.travelDates}</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-2548">
                  <DollarSignIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-2" data-id="element-2549" />
                  <div data-id="element-2550">
                    <p className="text-sm font-medium text-gray-500" data-id="element-2551">Budget</p>
                    <p className="text-gray-800" data-id="element-2552">{enquiry.budget}</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-2553">
                  <UsersIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-2" data-id="element-2554" />
                  <div data-id="element-2555">
                    <p className="text-sm font-medium text-gray-500" data-id="element-2556">
                      Travelers
                    </p>
                    <p className="text-gray-800" data-id="element-2557">{enquiry.travelers}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Activity Timeline */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-2558">
            <div className="p-6" data-id="element-2559">
              <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-2560">
                Activity Timeline
              </h2>
              {/* Add note form */}
              <div className="mb-6" data-id="element-2561">
                <div className="flex" data-id="element-2562">
                  <textarea className="flex-1 p-3 border border-gray-300 rounded-l-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" placeholder="Add a note or activity..." rows={2} value={newNote} onChange={e => setNewNote(e.target.value)} data-id="element-2563"></textarea>
                  <button className="px-4 bg-blue-600 text-white rounded-r-md hover:bg-blue-700 flex items-center" onClick={handleAddNote} data-id="element-2564">
                    <SendIcon className="h-4 w-4" data-id="element-2565" />
                  </button>
                </div>
                <div className="flex justify-end mt-2" data-id="element-2566">
                  <button className="text-xs text-blue-600 flex items-center mr-3" data-id="element-2567">
                    <MailIcon className="h-3 w-3 mr-1" data-id="element-2568" />
                    Log Email
                  </button>
                  <button className="text-xs text-blue-600 flex items-center mr-3" data-id="element-2569">
                    <PhoneIcon className="h-3 w-3 mr-1" data-id="element-2570" />
                    Log Call
                  </button>
                  <button className="text-xs text-blue-600 flex items-center" data-id="element-2571">
                    <PlusIcon className="h-3 w-3 mr-1" data-id="element-2572" />
                    More
                  </button>
                </div>
              </div>
              {/* Timeline */}
              <div className="space-y-4" data-id="element-2573">
                {enquiry.activities.map(activity => <div key={activity.id} className="flex" data-id="element-2574">
                    <div className="flex-shrink-0 mr-3" data-id="element-2575">
                      <div className="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-2576">
                        {getActivityIcon(activity.type)}
                      </div>
                    </div>
                    <div className="flex-1 bg-gray-50 rounded-lg p-4" data-id="element-2577">
                      <div className="flex justify-between items-start" data-id="element-2578">
                        <div data-id="element-2579">
                          <p className="text-sm font-medium text-gray-800" data-id="element-2580">
                            {activity.user}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-2581">
                            {formatDate(activity.date)}
                          </p>
                        </div>
                        <span className="text-xs text-gray-500 capitalize" data-id="element-2582">
                          {activity.type}
                        </span>
                      </div>
                      <p className="mt-2 text-sm text-gray-700" data-id="element-2583">
                        {activity.content}
                      </p>
                      {activity.type === 'quote' && <div className="mt-2 flex items-center" data-id="element-2584">
                          <span className="text-sm font-medium text-blue-600" data-id="element-2585">
                            Quote Amount: ${activity.quoteAmount}
                          </span>
                          <button className="ml-2 text-xs text-blue-600 underline" data-id="element-2586">
                            View Quote
                          </button>
                        </div>}
                      {activity.type === 'booking' && <div className="mt-2" data-id="element-2587">
                          <div className="flex items-center" data-id="element-2588">
                            <span className="text-sm font-medium text-green-600" data-id="element-2589">
                              Booking Amount: ${activity.bookingAmount}
                            </span>
                            <button className="ml-2 text-xs text-blue-600 underline" data-id="element-2590">
                              View Booking
                            </button>
                          </div>
                          <p className="text-xs text-gray-600" data-id="element-2591">
                            Booking Reference: {activity.bookingRef}
                          </p>
                        </div>}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
        {/* Sidebar - right 1/3 */}
        <div className="space-y-6" data-id="element-2592">
          {/* Customer info card */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-2593">
            <div className="p-6" data-id="element-2594">
              <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-2595">
                Customer Information
              </h2>
              <div className="flex items-center mb-4" data-id="element-2596">
                <div className="h-12 w-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 mr-3" data-id="element-2597">
                  <UserIcon className="h-6 w-6" data-id="element-2598" />
                </div>
                <div data-id="element-2599">
                  <p className="font-medium text-gray-800" data-id="element-2600">
                    {enquiry.customer.name}
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-2601">Customer</p>
                </div>
              </div>
              <div className="space-y-3" data-id="element-2602">
                <div className="flex items-center" data-id="element-2603">
                  <MailIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-2604" />
                  <a href={`mailto:${enquiry.customer.email}`} className="text-blue-600 hover:text-blue-800" data-id="element-2605">
                    {enquiry.customer.email}
                  </a>
                </div>
                <div className="flex items-center" data-id="element-2606">
                  <PhoneIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-2607" />
                  <a href={`tel:${enquiry.customer.phone}`} className="text-blue-600 hover:text-blue-800" data-id="element-2608">
                    {enquiry.customer.phone}
                  </a>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-2609">
                <button className="w-full px-4 py-2 bg-white border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 flex items-center justify-center" data-id="element-2610">
                  <UserIcon className="h-4 w-4 mr-2" data-id="element-2611" />
                  View Customer Profile
                </button>
              </div>
            </div>
          </div>
          {/* Actions card */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-2612">
            <div className="p-6" data-id="element-2613">
              <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-2614">
                Actions
              </h2>
              <div className="space-y-3" data-id="element-2615">
                <button className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center justify-center" onClick={handleCreateQuote} data-id="element-2616">
                  <FileTextIcon className="h-4 w-4 mr-2" data-id="element-2617" />
                  Create Quote
                </button>
                <button className="w-full px-4 py-2 bg-white border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 flex items-center justify-center" data-id="element-2618">
                  <PackageIcon className="h-4 w-4 mr-2" data-id="element-2619" />
                  Suggest Products
                </button>
                <button className="w-full px-4 py-2 bg-white border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 flex items-center justify-center" data-id="element-2620">
                  <MailIcon className="h-4 w-4 mr-2" data-id="element-2621" />
                  Send Email
                </button>
                <button className="w-full px-4 py-2 bg-white border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 flex items-center justify-center" data-id="element-2622">
                  <EditIcon className="h-4 w-4 mr-2" data-id="element-2623" />
                  Edit Enquiry
                </button>
              </div>
            </div>
          </div>
          {/* Status card */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-2624">
            <div className="p-6" data-id="element-2625">
              <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-2626">
                Enquiry Status
              </h2>
              <div className="space-y-3" data-id="element-2627">
                <div data-id="element-2628">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2629">
                    Current Status
                  </label>
                  <select className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-2630">
                    <option value="new" selected={enquiry.status === 'new'} data-id="element-2631">
                      New
                    </option>
                    <option value="in-progress" selected={enquiry.status === 'in-progress'} data-id="element-2632">
                      In Progress
                    </option>
                    <option value="quoted" selected={enquiry.status === 'quoted'} data-id="element-2633">
                      Quoted
                    </option>
                    <option value="booked" selected={enquiry.status === 'booked'} data-id="element-2634">
                      Booked
                    </option>
                    <option value="closed" selected={enquiry.status === 'closed'} data-id="element-2635">
                      Closed
                    </option>
                  </select>
                </div>
                <div data-id="element-2636">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2637">
                    Priority
                  </label>
                  <select className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-2638">
                    <option value="high" selected={enquiry.priority === 'high'} data-id="element-2639">
                      High
                    </option>
                    <option value="medium" selected={enquiry.priority === 'medium'} data-id="element-2640">
                      Medium
                    </option>
                    <option value="low" selected={enquiry.priority === 'low'} data-id="element-2641">
                      Low
                    </option>
                  </select>
                </div>
                <div data-id="element-2642">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2643">
                    Assigned To
                  </label>
                  <select className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" data-id="element-2644">
                    <option value="sarah" selected={enquiry.assignedTo === 'Sarah Johnson'} data-id="element-2645">
                      Sarah Johnson
                    </option>
                    <option value="david" selected={enquiry.assignedTo === 'David Miller'} data-id="element-2646">
                      David Miller
                    </option>
                    <option value="michael" data-id="element-2647">Michael Smith</option>
                    <option value="jennifer" data-id="element-2648">Jennifer Lee</option>
                  </select>
                </div>
                <button className="w-full mt-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-2649">
                  Update Status
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};